import {PANELMANAGER_SET_PANEL_TITLE_AND_ICON} from '../../constants';
import {AppDispatch, StoreState, Thunk} from '~/frontend/src/store';
import setPanelTitle from '~/frontend/src/actions/panelManager/setPanelTitle';
import setPanelIcon from '~/frontend/src/actions/panelManager/setPanelIcon';

export type SetPanelTitleAndIconAction = {
    type : typeof PANELMANAGER_SET_PANEL_TITLE_AND_ICON;
    panelKey : string;
    title : string;
    icon : string;
}

/**
 * @memberOf! Actions
 *
 * @param {String} panelKey
 * @param {String} title
 * @param {String} icon
 *
 * @return {SetPanelTitleAndIconAction}
 */
const setPanelTitleAndIcon = ( panelKey : string, title : string, icon : string ) : Thunk<void> => ( dispatch : AppDispatch, getState : () => StoreState ) => {
    dispatch( {
        type: PANELMANAGER_SET_PANEL_TITLE_AND_ICON,
        panelKey,
        title,
        icon
    } );

    dispatch( setPanelTitle( panelKey, title ) );
    dispatch( setPanelIcon( panelKey, icon ) );
}
export type SetPanelTitleAndIcon = typeof setPanelTitleAndIcon;

export default setPanelTitleAndIcon;
